/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


const dev = {
    API_DOMAIN: 'https://api-dev.pearson.com/gps/',
    API_KEY: 'WDXJHOqFDPzIj8LLf5LQFNqUJQzUo8uv',
    API_ORGANIZATOIN: 'Pearson',

    ALS_DOMAIN: 'https://dev.pearsonactivelearn.com/',
    ALS_MARK_BOOK: 'app/reports/markbook/list',

    
    
    ENVIRONMENT: 'dev',
    CLIENT_ID: 'tuA9zGJNrumMCM8q6QtVHATVREuqj8RF',
    IES_BASE_URL: 'https://login-stg.pearson.com/v1/piapi-int/',
    PRODUCT_MODEL_REGION: 'Everest',
	LAUNDING_URL: 'https://gps-dev-insights.pearson.com/'
    

};
export default dev;


    
   
 